export const ARROW_REGEX = /(\w+)\s*->\s*(\w+)\s*:\s*(.+)/;
export const MARGIN_BEFORE_FIRST_ARROW = 200;
export const GAP_BETWEEN_MESSAGES = 50;
export const MESSAGE_LABEL_OFFSET = 10;
export const ARROW_HEAD_SIZE = 10;
export const ARROW_HEAD_ANGLE = Math.PI / 6;
export const ARROW_VERTICAL_DIFF = 0;
export const MIDPOINT = 2;
